import { Dumbbell, Salad, Sunrise, Brain, Wind, Zap, Flame, Mic2 } from "lucide-react";
import { ScrollReveal } from "../ui/ScrollReveal";
import { PROGRAM_ITEMS } from "../../data/content";

const ICONS = { Dumbbell, Salad, Sunrise, Brain, Wind, Zap, Flame, Mic2 };

export const ProgramBreakdown = () => {
  return (
    <section id="active360" className="relative bg-[#020617] py-24 sm:py-32 px-5 sm:px-8" data-testid="program-breakdown-section">
      <div className="max-w-7xl mx-auto">
        <ScrollReveal>
          <span className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">
            Introducing Active360™
          </span>
          <h2 className="font-display font-extrabold uppercase text-2xl sm:text-3xl lg:text-4xl text-white mt-4 max-w-3xl leading-tight">
            Your Complete 365-Day Transformation Program.
          </h2>
          <p className="text-slate-400 text-sm sm:text-base mt-4 max-w-2xl">
            One subscription. One complete system. One year of transformation. Here's everything you get:
          </p>
        </ScrollReveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-800/60 border border-slate-800/60 rounded-2xl overflow-hidden">
          {PROGRAM_ITEMS.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <ScrollReveal
                key={item.n}
                delay={(i % 4) * 0.06}
                className="bg-[#0b1528] p-7 group hover:bg-[#0f1c38] transition-colors duration-300"
                data-testid={`program-item-${item.n}`}
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="font-display font-extrabold text-3xl text-slate-700 group-hover:text-cyan-500/40 transition-colors duration-300">
                    {item.n}
                  </span>
                  <Icon size={20} className="text-cyan-400" />
                </div>
                <h3 className="font-display font-bold text-base text-white leading-snug">{item.title}</h3>
                <p className="text-xs sm:text-sm text-slate-400 mt-2.5 leading-relaxed">{item.desc}</p>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
